const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3NzQsImNvbmdyZXNzSWQiOjEyNTksImRhdGUiOiIyMDIxLTA0LTI5VDA3OjAxOjA0LjUzNVoiLCJpYXQiOjE2MTk2Nzk2NjR9.DC5SUXwJ_eUrlgA6J0pfzO6w5m3civvSuDTJQXrqdd4';
const PLANNER_API_URL = 'https://eacs2021.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3NzUsImNvbmdyZXNzSWQiOjEyNTksImRhdGUiOiIyMDIxLTA0LTI5VDA3OjAxOjMyLjIxNVoiLCJpYXQiOjE2MTk2Nzk2OTJ9.pzLQ6o9zLp3Zp70Kxke4RCrD312juul3R0Z_PLbtD10';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1259;
const SUBMISSION_SYSTEM_URL = 'https://eacs2021.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_SYSTEM_URL,
  SESSION_GROUP_ID,
}